import { PartOptionGroupItem } from "../types/partOptionGroup";
import { BaseService } from "./BaseService";

export interface PutPartOptionGroupRequest {
  record: PartOptionGroupItem;
  oldRecord?: PartOptionGroupItem;
}
export interface PutPartOptionGroupsRequest {
  records: PartOptionGroupItem[];
  oldRecords: PartOptionGroupItem[];
  metaData?: string;
}

export default class PartOptionGroupService extends BaseService {
  async createPartOptionGroup(partRelationRequest: PutPartOptionGroupRequest): Promise<any> {
    const response = await this.submit("partoptiongroup", "POST", partRelationRequest);
    return response;
  }
  
  async updatePartOptionGroup(partRelationRequest: PutPartOptionGroupRequest): Promise<any> {
    const response = await this.submit(
      `UpdatePartOptionGroup/${partRelationRequest.record.id}`,
      "PUT",
      partRelationRequest,
    );
    return response;
  }
  
  async removePartOptionGroupById(id: string): Promise<any> {
    const response = await this.submit(`partoptiongroup/${id}`, "DELETE");
    return response;
  }
  
  async fetchPartOptionGroups(options: {
    id: string;
    onlyGroupsWithParts?: boolean;
    sortBy?: string;
    sortOrder?: string;
    customerId?: string;
  }): Promise<any> {
    const {
      id,
      onlyGroupsWithParts = false,
      sortBy,
      sortOrder,
      customerId
    } = options;
    
    const params = new URLSearchParams({
      OnlyGroupsWithParts: String(onlyGroupsWithParts),
      CustomerId: customerId || "",
    });
    if (sortBy) {
      params.append("sortBy", sortBy);
    }
    if (sortOrder) {
      params.append("sortOrder", sortOrder);
    }
    const query = `GetPartOptionGroup/${encodeURIComponent(id)}?${params.toString()}`;
    const response = await this.submit(query, "GET");
    return response;
  }
  
  async putPartOptionGroups(payload: { records: any; oldRecords: any }): Promise<any> {
    const { records, oldRecords } = payload;

    return this.submit(`putpartoptiongroups`, "PUT", {
      records,
      oldRecords,
      metaData: JSON.stringify({
        api_version: "2",
        process_type: "SAVE",
      }),
    });
  }
}
